import styled, { keyframes } from 'styled-components';
import { ButtonV2 } from '@getgrover/ui';

const hideAnimation = keyframes`
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`;

const slideAnimation = keyframes`
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(0);
    }
`;

export const Form = styled.form`
    position: relative;
    display: flex;
    flex-grow: 1;
    flex-direction: column;

    animation: ${({ animate }) => (animate ? hideAnimation : slideAnimation)} 200ms linear forwards;
`;

export const FormBody = styled.div`
    display: grid;
    grid-template-areas:
        'address1 address1 address2'
        'additional_info additional_info additional_info'
        'zipcode city city'
        'country_name country_name country_name';

    grid-gap: 24px 40px;
    grid-auto-columns: minmax(120px, 32%) minmax(auto, 40%) minmax(80px, 24%);
    grid-auto-rows: 52px;
    margin: 16px 0 24px;

    .error {
        .error-container {
            border-bottom: 2px solid rgba(243, 87, 87, 0.75);
        }

        .error-label {
            color: rgba(243, 87, 87, 0.25);
        }
    }
`;

export const InputField = styled.div`
    display: ${({ area }) => area === 'none' && 'none'};
    grid-area: ${({ area }) => area};

    label {
        width: 100%;

        span {
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
`;

export const Actions = styled.div`
    flex-grow: 1;
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-end;
`;

export const Error = styled.div`
    flex: 0 0 100%;
    margin-bottom: 24px;
    color: #f35757;
    font-style: italic;
    font-weight: bold;
    font-size: 12px;
    align-self: flex-start;
`;

export const BtnsWrapper = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    > * {
        max-width: 100%;
    }
`;

export const Btns = styled.div`
    flex: 1;
    display: flex;
    align-items: center;

    &:not(:only-child) {
        margin-top: 16px;
    }
`;

export const BackBtn = styled(ButtonV2)`
    margin-right: 16px;
    min-width: 112px;
    width: fit-content;
    text-overflow: ellipsis;
`;
